export interface TaskTemplateFields {
  content: string;
  description: string | null;
  priority: number;
  tagIds: string[];
  estimated_duration_minutes: number | null;
}

export interface ComposerDraft {
  title: string;
  parsedPriority: number | null;
  parsedTagIds: string[];
  dueDate: string | null;
}

export interface AppliedTaskTemplate {
  content: string;
  description: string | null;
  priority: number;
  tagIds: string[];
  estimated_duration_minutes: number | null;
  dueDate: string | null;
}

export function applyTaskTemplate(
  template: TaskTemplateFields,
  draft: ComposerDraft,
): AppliedTaskTemplate {
  const title = draft.title.trim();
  const tagIds: string[] = [];
  for (const id of [...template.tagIds, ...draft.parsedTagIds]) {
    if (!tagIds.includes(id)) tagIds.push(id);
  }

  return {
    content: title || template.content,
    description: template.description,
    priority: draft.parsedPriority ?? template.priority,
    tagIds,
    estimated_duration_minutes: template.estimated_duration_minutes,
    dueDate: draft.dueDate,
  };
}

/** Prefill the composer line: title + optional !priority token. Tags stay on the template. */
export function composerTextFromTemplate(template: TaskTemplateFields): string {
  if (template.priority === 3) return template.content;
  return `${template.content} !${template.priority}`;
}
